/** The stages a feature gate moves through, and how the admin Feature Gates page names them. */
export const FEATURE_GATE_RELEASE_STAGES = [
  'in_development',
  'trialing',
  'public_release',
] as const;

export type FeatureGateReleaseStage = (typeof FEATURE_GATE_RELEASE_STAGES)[number];

export const RELEASE_STAGE_LABELS: Record<FeatureGateReleaseStage, string> = {
  in_development: 'In development',
  trialing: 'Trialling',
  public_release: 'Public release',
};

export const RELEASE_STAGE_DESCRIPTIONS: Record<FeatureGateReleaseStage, string> = {
  in_development: 'Hidden from every office while the feature is being built.',
  trialing: 'Visible only to the selected trial offices.',
  public_release: 'Visible to every active office.',
};
